import { Versions } from 'models/version.model';
import apiClient from './base';

export const getVersions = async (): Promise<Versions> => {
  const { data } = await apiClient.get('/version');

  return data;
};
